import { Card, CardAction, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
interface SearchStatusProps {}

function SkeletonLine({ className = "" }: { className?: string }) {
  return <div className={`skeleton-shimmer rounded-full ${className}`.trim()} />;
}

function ContributorRowSkeleton() {
  return (
    <div className="draft-box bg-background/50 p-4">
      <div className="flex items-start gap-3">
        <div className="skeleton-shimmer size-11 shrink-0 rounded-full" />
        <div className="min-w-0 flex-1 space-y-3">
          <SkeletonLine className="h-4 w-40 max-w-[55%]" />
          <SkeletonLine className="h-3.5 w-full" />
          <SkeletonLine className="h-3.5 w-2/3" />
        </div>
        <SkeletonLine className="h-8 w-12 shrink-0 rounded-[10px]" />
      </div>
    </div>
  );
}

function RepoRowSkeleton() {
  return (
    <div className="draft-box bg-background/50 p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1 space-y-3">
          <SkeletonLine className="h-4 w-44 max-w-[65%]" />
          <SkeletonLine className="h-3.5 w-full" />
          <SkeletonLine className="h-3.5 w-3/4" />
        </div>
        <SkeletonLine className="h-8 w-16 shrink-0 rounded-[10px]" />
      </div>
    </div>
  );
}

export function SearchStatus({}: SearchStatusProps) {

  return (
    <div aria-live="polite" className="space-y-8">
      <Card className="bg-background/40">
        <CardHeader className="flex flex-row items-center justify-between gap-4">
          <CardTitle>Graph</CardTitle>
          <CardAction>
            <SkeletonLine className="h-8 w-20 rounded-[10px]" />
          </CardAction>
        </CardHeader>
        <CardContent>
          <div className="skeleton-shimmer h-[340px] rounded-[18px]" />
        </CardContent>
      </Card>

      <div className="grid gap-8 xl:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.8fr)]">
        <Card className="bg-background/40">
          <CardHeader className="flex flex-row items-center justify-between gap-4">
            <CardTitle>Engineers</CardTitle>
            <CardAction>
              <SkeletonLine className="h-5 w-6" />
            </CardAction>
          </CardHeader>
          <CardContent className="space-y-4">
            <ContributorRowSkeleton />
            <ContributorRowSkeleton />
            <ContributorRowSkeleton />
          </CardContent>
        </Card>

        <Card className="bg-background/40">
          <CardHeader className="flex flex-row items-center justify-between gap-4">
            <CardTitle>Repositories</CardTitle>
            <CardAction>
              <SkeletonLine className="h-5 w-6" />
            </CardAction>
          </CardHeader>
          <CardContent className="space-y-3">
            <RepoRowSkeleton />
            <RepoRowSkeleton />
            <RepoRowSkeleton />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
